import React from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import OWAncillaryContent from "./OWAncillaryContent";
import {Box} from "@mui/material";

const OWAncillaryContainer = () => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Box>
            <SectionHeader title={t("translation:auths.SCOPE_PRC_VIEW_OW_ANCILLARY_CONTAINER.name")}/>
            <OWAncillaryContent readOnly={false}/>
        </Box>
    );
};

export default OWAncillaryContainer;